import { render } from "./FilterList.vue?vue&type=template&id=66fbf335&scoped=true"
import script from "./FilterList.vue?vue&type=script&lang=js"
export * from "./FilterList.vue?vue&type=script&lang=js"

import "./FilterList.vue?vue&type=style&index=0&id=66fbf335&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fbf335"]])

export default __exports__